import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSsosKey } from '../../utils/keys';
export const useUpdateDefaultSsoStatus = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const ssosKey = getSsosKey();
    return useMutation(input => client.auth.updateDefaultSsoStatus(input), {
        onMutate: variables => {
            queryClient.setQueriesData(ssosKey, old => old.map(sso => ({
                ...sso,
                status: sso.type === variables.sso
                    ? variables.status
                    : sso.status,
            })));
        },
        onSettled: () => {
            queryClient.invalidateQueries(ssosKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateDefaultSsoStatus.js.map